import { Injectable } from '@angular/core';
import {CheckoutOrder, CheckoutService} from './checkout.service';
import { AuthService } from '../auth.service';
import { ConfiguratorStateService } from '../../ListConfiguration/configurator-state.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckoutHelperService {
  public currentOrder: CheckoutOrder | null = null;

  constructor(
      private checkoutService: CheckoutService,
      private auth: AuthService,
      private configState: ConfiguratorStateService,
  ) {}

  /**
   * Submits the purchase info to the backend.
   * Returns the observable for further handling.
   */
  sendPurchaseInfoToBackend(formValue: any, paymentMethod: 'Bank' | 'Paypal'): Observable<any> {
    this.currentOrder = {
      userId: this.auth.getUserId(),
      paymentMethod,
      customer: {
        companyName: formValue.companyName,
        firstname: formValue.firstname,
        lastname: formValue.lastname,
        email: formValue.email,
        address: formValue.address,
        town: formValue.town,
      },
      orderDetails: {
        table: this.configState.selectedTable,
        states: this.configState.selectedStates,
        infos: this.configState.selectedCompanyInfos,
        quantity: this.configState.selectedQuantity,
        price: this.configState.selectedPrice,
      }
    };
    return this.checkoutService.placeOrder(this.currentOrder);
  }
}
